import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Form, FormResult, Input } from '../../../../components/Form';
import firebase from "firebase/compat/app";
import { FirebaseAuth } from '../../../../components/FirebaseAuth/firebase';
import { AuthContext } from '../../../../components/FirebaseAuth';
import UserPageLayout from '../../../../components/user/UserPageLayout';
import { log, UPDATE_EMAIL } from '../../../../libs/log';

const UpdateEmail = () => {
    const { t } = useTranslation();
    const backToUrl = "/user/profile";
    const navigate = useNavigate();
    const mountedRef = useRef(true);

    const [emailAddress, setEmailAddress] = useState({
        hasError: false,
        error: null,
        value: null
    });
    const [password, setPassword] = useState({
        hasError: false,
        error: null,
        value: null
    });

    const { authUser } = useContext(AuthContext);

    const [result, setResult] = useState({
        status: null,
        message: ''
    });

    const [inSubmit, setInSubmit] = useState(false);

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);

    return (
        <UserPageLayout title={t('updateEmail.title')} >
            { result.status === null &&
                <Form handleSubmit={e => {
                    e.preventDefault();
                    setInSubmit(true);
                    // check password
                    const credential = firebase.auth.EmailAuthProvider.credential(
                        FirebaseAuth.auth().currentUser.email,
                        password.value
                    )
                    // update email address
                    authUser.user.reauthenticateWithCredential(credential)
                    .then(() => {
                        if (!mountedRef.current) return null
                        authUser.user.updateEmail(emailAddress.value).then(() => {
                            if (!mountedRef.current) return null
                            authUser.user.sendEmailVerification().then(() => {
                                if (!mountedRef.current) return null
                                log(UPDATE_EMAIL);
                                setResult({
                                    status: true,
                                    message: t('updateEmail.successMessageVerify')
                                });
                                setInSubmit(false);
                            }).catch(() => {
                                if (!mountedRef.current) return null
                                setResult({
                                    status: true,
                                    message: t('updateEmail.successMessageVerifyFallback')
                                });
                                setInSubmit(false);
                            })
                        }).catch(err => {
                            if (!mountedRef.current) return null
                            setResult({
                                status: false,
                                message: err.message
                            });
                            setInSubmit(false);
                        })
                    }).catch(() => {
                        if (!mountedRef.current) return null
                        setPassword({
                            hasError: true,
                            error: t('updateEmail.incorrectPassword'),
                            value: password.value
                        })
                        setInSubmit(false);
                    })
                }}
                disabled={emailAddress.hasError || password.hasError || emailAddress.value===null || password.value===null || inSubmit}
                inSubmit={inSubmit}
                enableDefaultButtons={true}
                backToUrl="/user/profile"
                >
                    <Input label={t('updateEmail.emailAddress')} type="email" name="email-address" hasError={emailAddress.hasError} error={emailAddress.error} minLen={5} maxLen={50} required={true} validRegex="^[a-zA-Z0-9-_+\.]*@[a-zA-Z0-9-_\.]*\.[a-zA-Z0-9-_\.]*$" changeHandler={setEmailAddress} fullWidth variant="outlined" />
                    <Input label={t('updateEmail.currentPassword')} type="password" name="password" hasError={password.hasError} error={password.error} required={true} changeHandler={setPassword} fullWidth variant="outlined" />
                </Form>
            }
            { result.status === false &&
                <FormResult
                    severity="error"
                    resultMessage={result.message}
                    primaryText={t('common.tryAgain')}
                    primaryAction={() => {
                        setResult({
                            status: null,
                            message: ''
                        })
                    }}
                    secondaryText={t('common.viewProfile')}
                    secondaryAction={() => {
                        navigate(backToUrl);
                    }}
                />
            }
            { result.status === true &&
                <FormResult
                    severity="success"
                    resultMessage={result.message}
                    primaryText={t('common.viewProfile')}
                    primaryAction={() => {
                        navigate(backToUrl);
                    }}
                />
            }
        </UserPageLayout>
    )
}

export default UpdateEmail;
